<fdr-past-performance-ui-table-state emptyTitle="PD.LABELS.NO_DATA_INTERVAL_TABLE_AVAILABLE" [emptySubtitle]="null" [isLoading]="isLoading()" [hasData]="rows().length > 0" [totalItems]="rows().length" [class.is-placeholder-state]="isLoading() || rows().length === 0">
  <dsy-table [data]="tableDataSignal()" [conf]="tableConfSignal()">
    @for (col of columnsSignal(); track col.key) {
      <div slot="header-{{ col.key }}">
        <div class="table-header__cell">  
        <dsy-heading level-size="lg">{{ col.header | translate }}</dsy-heading>
        <span  class="table-header__sort-icon" (click)="sortBy(col.key)">
            <dsy-icon library="material" name="swap_vert" density="default" elevation="auto" material-weight="400" material-grade="0" [color]="getHeaderIconColor(col.key)"></dsy-icon>
          </span>
        </div>
      </div>
    }

    @for (row of processedRows(); track $index; let i = $index) {
      <p class="table-cell table-cell--inline" slot="cell-{{ i }}-site">
        {{ row.site }}
      </p>

      <!-- 
	 TODO: check once admin endpoints implemented 
	  <div class="table-cell table-cell--datetime" slot="cell-{{ i }}-registration">
        <span class="table-cell__primary">
          {{ row.registrationLabel }}
        </span>
        <span class="table-cell__secondary">
          {{ row.site }}
        </span>
      </div>

      <p class="table-cell table-cell--inline" slot="cell-{{ i }}-organization">
        {{ row.organization }}
      </p> -->

      <p class="table-cell table-cell--inline" slot="cell-{{ i }}-enrolled">{{ row.enrolled  | number: '1.0-1' }} kW</p>

      <p class="table-cell table-cell--inline" slot="cell-{{ i }}-delivered">{{ row.delivered | number: '1.0-1' }} kW</p>

      <p class="table-cell table-cell--inline" slot="cell-{{ i }}-performance">{{ row.performance | number: '1.0-0' }}%</p>

      <p class="table-cell table-cell--inline" slot="cell-{{ i }}-dataQuality">
        {{ getDataQualityTranslationKey(row.dataQuality) | translate }}
      </p>
    }
  </dsy-table>

  <fdr-past-performance-ui-pagination [totalItems]="rows().length"></fdr-past-performance-ui-pagination>
</fdr-past-performance-ui-table-state>
